exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".addon-primary{background-color:#337ab7;color:#fff}.addon-primary:hover{background-color:#286090;color:#fff;cursor:pointer}.addon-success{background-color:#5cb85c;color:#fff}.addon-success:hover{background-color:#3f903f;color:#fff;cursor:pointer}.addon-danger{background-color:#d9534f;color:#fff}.addon-danger:hover{background-color:#c9302c;color:#fff;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-2a3cec57!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/CrematoryEdit.vue
// module id = 362
// module chunks = 0